import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import ModalWrapper from 'components/common/overlays/ModalWrapper';
import SingleBtn from 'components/common/elements/SingleBtn';
import Input from 'components/common/forms/Input';
import styles from 'styles/components/common/overlays/Modal.module.scss';
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import {
  ChangeChartNameFormFields,
  TChangeChartNameForm,
} from 'types/form/chart';
import { patchPracticeChartName } from 'apis/chart/studentPracticeChart';
import useModal from 'hooks/useModal';

type TProps = {
  chartId: number;
  chartName: string;
};

const ChangeChartName = ({ chartId, chartName }: TProps) => {
  const { closeModal } = useModal();
  const queryClient = useQueryClient();

  const methods = useForm<TChangeChartNameForm>({
    defaultValues: { newChartName: chartName },
  });
  const {
    handleSubmit,
    formState: { errors: formErrors },
    control,
  } = methods;

  const newChartName = useWatch({
    name: ChangeChartNameFormFields.NewChartName,
    control,
  });

  const { mutate: patchPracticeChartNameMutation } = useMutation(
    () => patchPracticeChartName(chartId, { newChartName }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('getPracticeChartList');
        closeModal();
      },
    }
  );

  const onValid = () => {
    patchPracticeChartNameMutation();
  };

  return (
    <ModalWrapper>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onValid)}>
          <header className={styles.title_wrapper}>
            <h2 className={styles.title}>연습용 차트 수정</h2>
            <button type="button" onClick={closeModal}>
              <CloseIcon alt="close" fill={STYLES_VARIABLES.GRAY_07} />
            </button>
          </header>
          <p>한글, 영문, 숫자 포함 최대 20자까지 작성할 수 있습니다.</p>
          <label className="block mt24 fw700">
            차트명 *
            <Input
              name={ChangeChartNameFormFields.NewChartName}
              type="text"
              inputStyle={{ fontWeight: '400', marginTop: '4px' }}
              rules={{
                required: '차트명을 입력해 주세요.',
                pattern: {
                  value: /^[a-zA-Z0-9가-힣\s]*$/,
                  message: '한글, 영문, 숫자만 입력할 수 있습니다.',
                },
                maxLength: {
                  value: 20,
                  message: '최대 20자까지 입력할 수 있습니다.',
                },
              }}
            />
          </label>
          {formErrors?.newChartName && (
            <p className={styles.error_msg}>
              {formErrors.newChartName.message}
            </p>
          )}
          <footer className="modal_btn_wrapper mt24">
            <SingleBtn
              btnText="취소"
              hasOutline={true}
              btnStyle={{
                width: '100%',
                fontSize: '14px',
              }}
              onClick={closeModal}
            />
            <SingleBtn
              type="submit"
              btnText="수정"
              isBtnActive={true}
              btnStyle={{
                width: '100%',
                fontSize: '14px',
              }}
            />
          </footer>
        </form>
      </FormProvider>
    </ModalWrapper>
  );
};

export default ChangeChartName;
